import React from 'react';

const RestaurentSection = () => {
    return (
        <h3>Restaurants section</h3>
    );
};

export default RestaurentSection;